export default __webpack_public_path__ + "static/media/RUNNING.BRAND.JDIS_5K.963fa7c9.jpg";